import { useState } from 'react';
import { Tooltip } from 'antd';
import moment from 'moment';
import { getProjectPriceChanges } from '@gtintel/platform-api';
import Table from '../../Table';
import * as S from '../styles';
import ValueChangeCell from './ValueChangeCell';
const PriceChangeTable = ({
  projectId
}) => {
  const [priceChanges, setPriceChanges] = useState([]);
  useState(() => {
    getProjectPriceChanges(projectId).then(changes => setPriceChanges(changes.results)).catch(() => {});
  });
  const columns = [{
    key: 'change_date',
    dataIndex: 'change_date',
    title: 'Date',
    width: 50,
    render: change_date => <Tooltip title={moment(change_date).format('YYYY-MM-DD HH:mm:ss')}>
          <p>{moment(change_date).fromNow()}</p>
        </Tooltip>
  }, {
    key: 'revenue',
    dataIndex: 'revenue',
    title: 'Revenue',
    width: 20,
    render: (text, record) => <ValueChangeCell old_value={record?.old_revenue.toLocaleString() + record.old_currency.toUpperCase()} new_value={record?.new_revenue.toLocaleString() + record.new_currency.toUpperCase()} />
  }, {
    key: 'cost',
    dataIndex: 'cost',
    title: 'Cost',
    width: 20,
    render: (text, record) => <ValueChangeCell old_value={record?.old_cost.toLocaleString() + record.old_currency.toUpperCase()} new_value={record?.new_cost.toLocaleString() + record.new_currency.toUpperCase()} />
  }, {
    key: 'actor',
    dataIndex: 'actor',
    title: 'Changed By',
    width: 50
  }];
  // TODO: Pagination. We're unlikely to get more than 10 entries here so it's not a priority.
  return <S.Container>
      <S.Header>Recent Changes</S.Header>
      <Table columns={columns} dataSource={priceChanges} onChange={function () {}}></Table>
    </S.Container>;
};
export default PriceChangeTable;